import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': {
        '& $title': {
          color: SecondaryColors.dark,
        },
      },
      '&.dark-theme': {
        '& $title': {
          color: SecondaryColors.main,
        },
      },
      width: '100%',
    },

    title: {
      '&.MuiTypography-root': {
        marginBottom: '12px',
      },
    },

    columns: {
      display: 'flex',

      '& .column': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignContent: 'flex-start',

        '& > *': {
          width: '100%',
        },
      },

      [muiTheme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },

    column: {
      '&': {
        [muiTheme.breakpoints.up('md')]: {
          width: '33.333333333%',
          flexGrow: 1,

          '&:not(:first-child)': {
            marginLeft: muiTheme.spacing(7),
          },
        },

        [muiTheme.breakpoints.down('sm')]: {
          width: '100%',

          '&:not(:last-child)': {
            marginBottom: muiTheme.spacing(3),
          },
        },
      },

      '& p:not(:last-child)': {
        marginBottom: muiTheme.spacing(3),
      },

      '&.column-auto': {
        width: 'auto',
      },
    },
  }),
  { name: 'GenThreeColumnContent' },
);

export default useStyles;
